var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SubmitAddAddress, SubmitDeliveryAddressCreateCart, SubmitValidateDeliveryAddress, } from '../../api/oms/edit-delivery-address';
import { FLOW_TYPES } from '../../constants/out-of-stock';
import { OmmEditDeliveryAddressAppify } from '../../hooks/delivery-hooks';
import { TrackErrorEventEditDeliveryAddressAnalytics } from './analytics';
import { isBopisOutOfStockRecoverable } from '../../components/order-details/util/FulfillmentStatus';
import { FeatureSwitches } from '../../constants/feature-switches';
/**
 * @param lineItems LineItems array from fulfillmentGroup (OrderDetailsResponse).
 * @returns Array of lineIds or empty array.
 */
export var mapLineIds = function (lineItems) {
    return ((lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter(function (lineItem) {
        return !(lineItem === null || lineItem === void 0 ? void 0 : lineItem.parentLine) && !(lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineParentId);
    }).map(function (lineItem) { var _a; return (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineId) !== null && _a !== void 0 ? _a : ''; })) || []);
};
export var submitEditDeliveryAddress = function (_a) {
    var deliveryAddress = _a.deliveryAddress, firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, isDefaultValue = _a.isDefaultValue, orderDetailsData = _a.orderDetailsData, fulfillmentTypeCode = _a.fulfillmentTypeCode, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, isAddingNewAddress = _a.isAddingNewAddress, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, fulfillmentGroup = _a.fulfillmentGroup, traceId = _a.traceId, setIsChangeForm = _a.setIsChangeForm, setIsDeliveryDetails = _a.setIsDeliveryDetails, setIsLoading = _a.setIsLoading, setShowDrawerError = _a.setShowDrawerError, setIsExcludedAddress = _a.setIsExcludedAddress, setIsValidated = _a.setIsValidated, closeDrawer = _a.closeDrawer, setUpdatedAddressData = _a.setUpdatedAddressData, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, flowType = _a.flowType;
    var addAddressRequestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        flowType: flowType,
        address: __assign(__assign({}, deliveryAddress), { firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue, isDefault: isDefaultValue }),
        fulfillmentType: fulfillmentTypeCode,
    };
    var createCart = function () {
        SubmitDeliveryAddressCreateCart({
            requestData: deliveryAddressCreateCartRequestData,
            setIsChangeForm: setIsChangeForm,
            setIsDeliveryDetails: setIsDeliveryDetails,
            setIsLoading: setIsLoading,
            setShowDrawerError: setShowDrawerError,
            setIsExcludedAddress: setIsExcludedAddress,
            setIsValidated: setIsValidated,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            fulfillmentGroup: fulfillmentGroup,
            closeDrawer: closeDrawer,
            setUpdatedAddressData: setUpdatedAddressData,
            setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
            traceId: traceId,
        });
    };
    if (isAddingNewAddress) {
        // SubmitAddAddress is fire-and-forget (regardless of success or error we currently continue with no feedback to customer)
        SubmitAddAddress(addAddressRequestData, traceId);
    }
    createCart();
};
export var getAddresses = function (_a) {
    var orderDetailsData = _a.orderDetailsData, fulfillmentTypeCode = _a.fulfillmentTypeCode, isAuthTHDUser = _a.isAuthTHDUser, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, setDeliveryAddresses = _a.setDeliveryAddresses, setDeliveryAddressesApiError = _a.setDeliveryAddressesApiError, closeDrawer = _a.closeDrawer;
    var isBopisOutOfStock = isBopisOutOfStockRecoverable(fulfillmentGroup);
    var isBopisOutOfStockFfaLiteCall = Boolean(FeatureSwitches.enableBopisOutOfStockFfaLiteCall);
    var editDeliveryRequest = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        flowType: isBopisOutOfStockFfaLiteCall && isBopisOutOfStock
            ? FLOW_TYPES.BOPIS_OOS_RECOVERY
            : FLOW_TYPES.EDIT_DELIVERY_ADDRESS,
        fulfillmentType: fulfillmentTypeCode,
    };
    return OmmEditDeliveryAddressAppify(editDeliveryRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
        .then(function (response) {
        var _a, _b;
        setDeliveryAddresses(((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.addresses) || []);
        setDeliveryAddressesApiError(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
        });
    })
        .catch(function () {
        setDeliveryAddressesApiError(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
        });
        closeDrawer();
    });
};
export var goBackToChangeForm = function (suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails) {
    setSubmitCreateForm(false);
    setIsChangeForm(true);
    if (setIsConfirmation)
        setIsConfirmation(false);
    if (setIsDeliveryDetails)
        setIsDeliveryDetails(false);
    suspendCartCheck();
};
export var goBackToDeliveryDetails = function (suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails) {
    setIsChangeForm(false);
    if (setIsConfirmation)
        setIsConfirmation(false);
    if (setIsDeliveryDetails)
        setIsDeliveryDetails(true);
    suspendCartCheck();
};
export var validateDeliveryAddress = function (_a) {
    var _b;
    var firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, streetAddressValue = _a.streetAddressValue, addressLineTwoValue = _a.addressLineTwoValue, zipCodeValue = _a.zipCodeValue, cityStateValue = _a.cityStateValue, country = _a.country, flowType = _a.flowType, fulfillmentTypeCode = _a.fulfillmentTypeCode, orderDetailsData = _a.orderDetailsData, setInvalidField = _a.setInvalidField, setIsSameAddress = _a.setIsSameAddress, setIsLoading = _a.setIsLoading, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails, setShowDrawerError = _a.setShowDrawerError, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, setIsValidated = _a.setIsValidated, closeDrawer = _a.closeDrawer, setValidationEt = _a.setValidationEt, validationEt = _a.validationEt, traceId = _a.traceId, deliveryAddress = _a.deliveryAddress, checkSameAddress = _a.checkSameAddress, isPOBoxAddressLine1 = _a.isPOBoxAddressLine1, isPOBoxAddressLine2 = _a.isPOBoxAddressLine2, setSubmitCreateForm = _a.setSubmitCreateForm, EditDeliveryAddressErrorMessages = _a.EditDeliveryAddressErrorMessages, isValidated = _a.isValidated, isAddressList = _a.isAddressList;
    if (firstNameValue === '' ||
        lastNameValue === '' ||
        phoneNumberValue.length !== 12 ||
        streetAddressValue === '' ||
        zipCodeValue.length !== 5) {
        setInvalidField(true);
        TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', 'n/a', 'Invalid fields', 'advisory');
        return;
    }
    if (checkSameAddress()) {
        setIsSameAddress(true);
        TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', 'n/a', EditDeliveryAddressErrorMessages.SAME_ADDRESS, 'advisory');
        return;
    }
    if (isPOBoxAddressLine1 || isPOBoxAddressLine2) {
        return;
    }
    setIsLoading(true);
    setNewDeliveryAddressDetails(__assign(__assign({}, deliveryAddress), { firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue }));
    var requestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        address: {
            addressLine1: streetAddressValue,
            addressLine2: addressLineTwoValue,
            city: cityStateValue.split(',')[0],
            state: (_b = cityStateValue.split(',')[1]) === null || _b === void 0 ? void 0 : _b.trim(),
            zipCode: zipCodeValue,
            country: country,
        },
        flowType: flowType,
        fulfillmentType: fulfillmentTypeCode,
    };
    SubmitValidateDeliveryAddress(requestData, isValidated, setSubmitCreateForm, setShowDrawerError, fulfillmentGroupIndex, setIsValidated, closeDrawer, setIsLoading, setValidationEt, validationEt, isAddressList, traceId);
};
